import { useState, useEffect } from 'react';
import { Capacitor } from '@capacitor/core';

interface KeyboardSafeAreaState {
  isKeyboardOpen: boolean;
  keyboardHeight: number;
  adjustedPaddingBottom: string;
}

export const useKeyboardSafeArea = () => {
  const [keyboardState, setKeyboardState] = useState<KeyboardSafeAreaState>({
    isKeyboardOpen: false,
    keyboardHeight: 0,
    adjustedPaddingBottom: '0px'
  });

  useEffect(() => {
    const platform = Capacitor.getPlatform();
    
    if (platform === 'ios') {
      // Listen for keyboard events
      const handleKeyboardWillShow = (event: any) => {
        const keyboardHeight = event.keyboardHeight || 0;
        setKeyboardState({
          isKeyboardOpen: true,
          keyboardHeight,
          adjustedPaddingBottom: '0px' // Remove bottom padding when keyboard is open
        });
        
        // Update CSS custom property
        document.documentElement.style.setProperty('--safe-padding-bottom', '0px');
        
        console.log('iOS Keyboard opened, height:', keyboardHeight);
      };

      const handleKeyboardWillHide = () => {
        setKeyboardState({
          isKeyboardOpen: false,
          keyboardHeight: 0,
          adjustedPaddingBottom: '34px' // Restore bottom padding when keyboard closes
        });
        
        // Restore CSS custom property
        document.documentElement.style.setProperty('--safe-padding-bottom', '34px');
        
        console.log('iOS Keyboard closed');
      };

      // Add event listeners
      window.addEventListener('keyboardWillShow', handleKeyboardWillShow);
      window.addEventListener('keyboardWillHide', handleKeyboardWillHide);

      // Also listen for focus events on input elements
      const handleInputFocus = () => {
        setKeyboardState(prev => ({
          ...prev,
          isKeyboardOpen: true,
          adjustedPaddingBottom: '0px'
        }));
        document.documentElement.style.setProperty('--safe-padding-bottom', '0px');
      };

      const handleInputBlur = () => {
        setKeyboardState(prev => ({
          ...prev,
          isKeyboardOpen: false,
          adjustedPaddingBottom: '34px'
        }));
        document.documentElement.style.setProperty('--safe-padding-bottom', '34px');
      };

      // Add focus/blur listeners to all input elements
      document.addEventListener('focusin', handleInputFocus);
      document.addEventListener('focusout', handleInputBlur);

      return () => {
        window.removeEventListener('keyboardWillShow', handleKeyboardWillShow);
        window.removeEventListener('keyboardWillHide', handleKeyboardWillHide);
        document.removeEventListener('focusin', handleInputFocus);
        document.removeEventListener('focusout', handleInputBlur);
      };
    }
  }, []);

  return keyboardState;
};
